import { render, staticRenderFns } from "./Wise_rentunit3.vue?vue&type=template&id=6a2bc20d&scoped=true"
import script from "./Wise_rentunit3.vue?vue&type=script&lang=js"
export * from "./Wise_rentunit3.vue?vue&type=script&lang=js"
import style0 from "./Wise_rentunit3.vue?vue&type=style&index=0&id=6a2bc20d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bc20d",
  null
  
)

export default component.exports